// chartSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  loadChartSession,
  saveChartSession,
} from "../../pages/Dashboards/live_data/Components/DraggableChart/utils";

const persisted = loadChartSession();

const chartSlice = createSlice({
  name: "chart",
  initialState: {
    sensors: persisted.sensors ?? [],
    chartView: persisted.chartView ?? "closed", // "open" | "closed"
    chartMinimized: persisted.chartMinimized ?? false,
  },
  reducers: {
    setSyncSensors: (state, action) => {
      state.sensors = action.payload;
      state.chartView = "open";
      saveChartSession({ sensors: state.sensors, chartView: state.chartView });
    },
    setSyncChartView: (state, action) => {
      state.chartView = action.payload;
      saveChartSession({
        chartView: state.chartView,
        chartMinimized: state.chartMinimized,
      });
    },
    setChartMinimized: (state, action) => {
      state.chartMinimized = action.payload;
      if (state.chartView === "closed" && action.payload)
        state.chartView = "open";
      saveChartSession({
        chartView: state.chartView,
        chartMinimized: state.chartMinimized,
        sensors: state.sensors,
      });
    },
    closeChartView: (state) => {
      saveChartSession({
        chartView: "closed",
        sensors: [],
        chartMinimized: false,
      });

      state.chartView = "closed";
      state.sensors = [];
      state.chartMinimized = false;
    },
    addSyncSensor: (state, action) => {
      const s = action.payload;
      const exists = state.sensors.some(
        (x) => x.value === s.value && x.ship === s.ship
      );
      if (!exists) state.sensors.push(s);
      state.chartView = "open";
      saveChartSession({
        sensors: state.sensors,
        chartView: "open",
        chartMinimized: state.chartMinimized,
      });
    },
  },
});

export const {
  setSyncSensors,
  setSyncChartView,
  closeChartView,
  addSyncSensor,
  setChartMinimized,
} = chartSlice.actions;

export default chartSlice.reducer;
